import { styled } from '@mui/material';
import { Typography } from 'shared/mui/Typography';

export const StyledTypography = styled(Typography)(({ theme }) => ({
  width: 'fit-content',
  cursor: 'pointer',
  color: theme.palette.success.main,
}));
